// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1506":"c5bcc9a8","3701":"b61e930b","4752":"96750395","6071":"75336afb","6170":"3b53517f"}[chunkId] + ".chunk.css";
};